import { Controller } from "@hotwired/stimulus";
import anime from "animejs";
import { useWindowResize } from "stimulus-use";

export default class extends Controller {
    static targets = [
        'image',
    ];

    connect() {
        useWindowResize(this)

        this.handleScroll = (event) => {
            const rect = this.element.getBoundingClientRect();
            const innerHeight = window.innerHeight;
            const elementHeight = rect.height / 2;
            const elementTop = rect.top + innerHeight;
            const elementBottom = rect.bottom;

            // Блок сверху
            let procent = 0;

            // Блок виден
            if (elementTop < innerHeight && elementBottom >= 0) {
                procent = ((innerHeight - elementTop) / (innerHeight + elementHeight)) * 100
            }

            // Блок снизу
            if (elementBottom <= 0) {
                procent = 100;
            }

            this.setSeek(procent)
        }

        addEventListener('scroll', this.handleScroll)

        this.elipce = anime({
            targets: this.imageTarget.querySelector('ellipse#line'),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'linear',
            // duration: 1500,
            direction: 'alternate',
            loop: false,
            autoplay: false,
        });

        this.recalc()
    }

    windowResize() {
        this.recalc()
    }

    recalc() {
        const isMobile = window.innerWidth < 769

        // 
        const mobile = {
            width:"700",
            height:"700",
            viewBox:"320 50 700 700",
        }

        // 
        const original = {
            width:"1400",
            height:"800",
            viewBox:"0 0 1400 800",
        }

        const obj = isMobile ? mobile : original

        for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
                this.imageTarget.setAttribute([key], obj[key]);
            }
        }
        // Object.assign(this.imageTarget, isMobile ? mobile : original)
    }

    setSeek(procent) {
        this.elipce.seek(this.elipce.duration * (procent / 100))

        this.element.classList.toggle('ecosystem-show-0', procent > 0)
        this.element.classList.toggle('ecosystem-show-1', procent > 12.5)
        this.element.classList.toggle('ecosystem-show-2', procent > 25)
        this.element.classList.toggle('ecosystem-show-3', procent > 12.5 * 3)
        this.element.classList.toggle('ecosystem-show-4', procent > 50)
        this.element.classList.toggle('ecosystem-show-5', procent > 12.5 * 5)
        this.element.classList.toggle('ecosystem-show-6', procent > 75)
        this.element.classList.toggle('ecosystem-show-7', procent > 12.5 * 7)
        this.element.classList.toggle('ecosystem-show-8', procent > 99)
    }

    disconnect() {
        removeEventListener('scroll', this.handleScroll)
        anime.remove(this.imageTarget.querySelector('ellipse#line'))
    }
}
